import loadApp from '~/services/bootstrap';
import App from './app.vue';

loadApp('#va-loan-app', App);
